export default __webpack_public_path__ + "img/logo.d4dc3f52.svg";